module.exports = __webpack_public_path__ + "img/ic_product_box.96dcd118.svg";